import { render, staticRenderFns } from "./LicenseSearchField.vue?vue&type=template&id=2fb9967c&scoped=true"
import script from "./LicenseSearchField.vue?vue&type=script&lang=ts"
export * from "./LicenseSearchField.vue?vue&type=script&lang=ts"
import style0 from "./LicenseSearchField.vue?vue&type=style&index=0&id=2fb9967c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9967c",
  null
  
)

export default component.exports